import React, { useState } from "react";
import styles from "./setting.module.css";
import {
  FaChevronRight,
  FaUsers,
  FaUserSecret,
  FaUserCheck,
} from "react-icons/fa"; // Import icons

// import AccountManagmnet from "./AccountManagment/AccountManagmnet";
import Passwordmanagment from "./Passwordmanagment/Passwordmanagment";
import TwoFactors from "./TwoFactors/TwoFactors";
import NotificationSettings from "./NotificationSettings/NotificationSettings";
import CommunicationMethods from "./CommunicationMethod/CommunicationMethods";
import PrivacySettings from "./PrivacySetting/PrivacySettings";
import Private from "./Private/Private";
import VerifiedUser from "./VerifiedUser/VerifiedUser";
import { Modal, TextComponent } from "../../components";
import { PiRadioButton, PiRadioButtonFill } from "react-icons/pi";
import ThemeColor from "./ThemeColor/ThemeColor";
import SupervisorPin from "./SupervisorPin/SupervisorPin";
import LanguagePreference from "./LanguagePreference/LanguagePreference";
import TimezoneSettings from "./Timezone/TimezoneSettings";
import { roles } from "../../config/roles";

const visible = ["Public", "Private", "Verified Users"];
const Settings = () => {
  const Admintabs = [
    // {
    //   id: "account",
    //   label: "Account Management",
    //   Component: <AccountManagmnet />,
    // },
    {
      id: "password",
      label: "Password Management",
      Component: <Passwordmanagment />,
    },
    {
      id: "2fa",
      label: "Two-Factor Authentication",
      Component: <TwoFactors />,
    },
    { id: "theming", label: "Theme Colour", Component: <ThemeColor /> },
    { id: "SP", label: "Supervisor Pin", Component: <SupervisorPin /> },
    // {
    //   id: "LP",
    //   label: "Language Preference",
    //   isHeading: true,
    // },
    {
      id: "Lp",
      label: "Language Preference",
      Component: <LanguagePreference />,
    },
    {
      id: "timezone",
      label: "Timezone",
      Component: <TimezoneSettings />,
    },
    {
      id: "Np",
      label: "Notification Preference",
      Component: <NotificationSettings />,
    },
  ];

  const SupervisorAndStafftabs = [
    {
      id: "password",
      label: "Password Management",
      Component: <Passwordmanagment />,
    },
    {
      id: "2fa",
      label: "Two-Factor Authentication",
      Component: <TwoFactors />,
    },
    { id: "theming", label: "Theme Colour", Component: <ThemeColor /> },

    {
      id: "Lp",
      label: "Language Preference",
      Component: <LanguagePreference />,
    },

    {
      id: "Np",
      label: "Notification Preference",
      Component: <NotificationSettings />,
    },
  ];
  const role = localStorage.getItem("@role");
  const tabs = role === roles.admin ? Admintabs : SupervisorAndStafftabs;
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [visibleUser, setVisibleUser] = useState(visible[0]);

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.sidebar}>
        <TextComponent text="Settings" className={styles.heading} />
        {tabs?.map((tab) =>
          tab.isHeading ? (
            <TextComponent key={tab.id} className={styles.heading}>
              {tab.label}
            </TextComponent>
          ) : (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab.id === tab.id ? styles.active : ""
                } ${tab.isPrivacyOption ? styles.privacyOption : ""}`}
              onClick={() => tab.Component && setActiveTab(tab)}
            >
              <TextComponent
                className={`${activeTab.id === tab.id
                    ? styles.ActivetabLabel
                    : styles.tabLabel
                  }`}
              >
                {tab.icon && <span className={styles.icon}>{tab.icon}</span>}{" "}
                {tab.label}
              </TextComponent>
              {!tab.isPrivacyOption && (
                <FaChevronRight className={styles.rightIcon} />
              )}
            </button>
          )
        )}
      </div>
      <div className={styles.content}>
        {activeTab.Component ? activeTab.Component : <p>Select an option</p>}
      </div>
    </div>
  );
};

export default Settings;
